<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144006' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151036' | translate}}</mat-label>
            <input matInput [readonly]="!isCreate" placeholder="{{'ml_144051' | translate}}" formControlName="apexId" (keyup)="onDriverApexIDOrNameKeyUp($event)" />
          </mat-form-field>
        </div>
        <div class="col">
          <div class="mt-3">{{ editForm.controls["driverName"].value }}</div>
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143930' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="apexId" />
          </mat-form-field> -->
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <app-driver-search-grid [filterText$]="driverApexIDOrNameFilter$" (itemToggled)="onDriverItemClicked($event)"></app-driver-search-grid>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ml_144038' | translate}}</mat-label>
            <mat-select formControlName="kpi_Id" [disabled]="processing$ | async">
              @for (item of kpiSelectItems$ | async; track $index) {
              <mat-option [value]="item.kpi_Id">
                {{item.kpi_Translation_Id | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_144009' | translate)}}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="kpiTime">
            <mat-hint>{{'ml_151231' | translate}}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144010' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="title" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143964' | translate}}</mat-label>
            <textarea matInput placeholder="" formControlName="description" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100 file-selector">
            <mat-label>{{'ml_144011' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="attachment" />
            <button type="button" mat-raised-button (click)="fileInput.click()">{{'ml_144144' | translate}}</button>
            <span class="ms-3">{{ 'ml_151172' | translate }}</span>
          </mat-form-field>
          <input hidden (change)="onFileSelected($event)" type="file" #fileInput id="file">
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
